// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3ir31","boxTitle":"Qualiphy_boxTitle__3Hzlt","box":"Qualiphy_box__3Uo7t","toggleWrap":"Qualiphy_toggleWrap__10-Vh"};